import React from "react";
import { TextField } from "@material-ui/core";
import "./lp-field.css";

const LpField = React.forwardRef(function LpField(props, ref) {
  const { className, variant = "outlined", ...rest } = props;
  const composed = className ? `lp-field ${className}` : "lp-field";
  return <TextField ref={ref} variant={variant} className={composed} {...rest} />;
});

export default LpField;
